import React from "react";
import styled from "styled-components";
import FilterTag from "../library/FilterTag";
import { useSearchFiltersContext } from "../library/SearchFilter";
import { FilterData } from "./EngagementsListPage";
import { mediaMaxWidth } from "../../theme/mediaQueriesTemplates";

const EngagementListSelectedFilters = (props: Props) => {
  const { filters } = props;

  const statusTags = filters.status
    .filter((status) => Boolean(status))
    .map((status) => ({
      label: status === "accepted" ? "active" : status,
      value: status,
    }));

  const jobTypeTags = filters.jobType.map((type) => ({
    label: type,
    value: type,
  }));

  return (
    <SelectedFiltersWrapper id="engagements-filter-tags">
      <FilterTagGroup tags={statusTags} filter="status" />
      <FilterTagGroup tags={jobTypeTags} filter="jobType" />
    </SelectedFiltersWrapper>
  );
};

type Tag = {
  label: string;
  value: string | string[];
};

const FilterTagGroup = (props: { filter: string; tags: Tag[] }) => {
  const { tags, filter } = props;
  const { remove } = useSearchFiltersContext();

  if (tags.length === 0) {
    return null;
  }

  return (
    <>
      {tags.map(({ label, value }) => (
        <FilterTag
          key={`${label}-${JSON.stringify(value)}`}
          onClick={() => remove(filter, value)}
        >
          {label}
        </FilterTag>
      ))}
    </>
  );
};

const SelectedFiltersWrapper = styled.div`
  margin-bottom: 0.5rem;
  margin-left: -0.25rem;
  margin-right: -0.25rem;

  ${mediaMaxWidth.smallTablet} {
    display: none;
  }
`;

type Props = {
  filters: FilterData;
};

export default EngagementListSelectedFilters;
